<template>
  <div class="detail-container">
    <h1>建物情報詳細</h1>
    <div v-if="building">
      <div v-if="building.m_customer">
        <table class="table table-bordered">
          <tr>
            <th>顧客名</th>
            <td>{{ building.m_customer.customer_nm }}</td>
          </tr>
          <tr>
            <th>区分</th>
            <td>{{ building.m_building_type.building_type_nm }}</td>
          </tr>
          <tr>
            <th>建物名</th>
            <td>{{ building.building_nm }}</td>
          </tr>
          <tr>
            <th>所在地</th>
            <td>〒{{ building.postal_code }} {{building.prefecture}}{{building.city}}{{building.other_address}}</td>
          </tr>
          <tr>
            <th>電話番号</th>
            <td>{{ building.tel_num }}</td>
          </tr>
          <tr>
            <th>契約日</th>
            <td>{{ building.contract_dt }}</td>
          </tr>
          <tr>
            <th>担当者</th>
            <td>{{ building.in_charge_nm }}</td>
          </tr>
          <tr>
            <th>携帯番号</th>
            <td>{{ building.in_charge_phone_num }}</td>
          </tr>
          <tr>
            <th>担当者メールアドレス</th>
            <td>{{ building.in_charge_email }}</td>
          </tr>
        </table>

        <div class="btn-area">
          <router-link :to="{ name: 'BuildingList', params: { id: building.id }}"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-primary">一覧へ</button>
          </router-link>

          <router-link v-if="isAdmin" :to="{ name: 'BuildingEdit', params: { id: building.id }}"> <!-- 顧客情報編集ページへのリンク -->
            <button type="button" class="btn btn-success mx-2">編集</button>
          </router-link>
        </div>
      </div>
      <div v-else>
        顧客情報情報を読み込み中...
      </div>
    </div>
    <!-- その他の詳細情報 -->
    <div v-else>
      建物情報情報を読み込み中...
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watchEffect, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { getBuilding } from '@/api/axios';
import { currentRoleFromStoreOrLocalStorage, isAdminRole } from '@/utils/roleAuthorization';

export default {
  setup() {
    const title = ref('建物情報詳細');
    const store = useStore();

    watchEffect(() => {
      document.title = title.value;
    });

    const isAdmin = computed(() => isAdminRole(currentRoleFromStoreOrLocalStorage(store.state.userRole)));
    const building = ref({});
    const route = useRoute();
    const buildingId = route.params.id;

    const fetchBuilding = async () => {
      const response = await getBuilding(buildingId, { include_visibility_hidden: true });
      building.value = response.data;
    };

    onMounted(fetchBuilding);

    return {
      title,
      isAdmin,
      building
    };
  }
};
</script>

<style scoped>
.detail-container {
  width: 70%;
  padding: 20px;
  margin: auto;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.detail-item {
  margin-bottom: 10px;
}

table th {
  background: #2c3e50;
  color: #fff;
}

table th,
table td{
  padding: 8px;
}

.btn-area{
  text-align: center;
}
</style>
